import { render, staticRenderFns } from "./ChoosePicklTypePopup.vue?vue&type=template&id=76b98b7c&scoped=true&"
import script from "./ChoosePicklTypePopup.vue?vue&type=script&lang=ts&"
export * from "./ChoosePicklTypePopup.vue?vue&type=script&lang=ts&"
import style0 from "./ChoosePicklTypePopup.vue?vue&type=style&index=0&id=76b98b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b98b7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b98b7c')) {
      api.createRecord('76b98b7c', component.options)
    } else {
      api.reload('76b98b7c', component.options)
    }
    module.hot.accept("./ChoosePicklTypePopup.vue?vue&type=template&id=76b98b7c&scoped=true&", function () {
      api.rerender('76b98b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ChoosePicklTypePopup.vue"
export default component.exports